import React, { useEffect, useState } from 'react'
import AdministraciónCaso from './administracion-Caso'
import { useDispatch, useSelector } from 'react-redux'
import { configuracionFormAction41, obtenerDatosGestion ,obtenerComboAmbitoGestion, PostRecepciona} from '../../../store/actions/recepciona-caso-action'
import {validationSchemas} from '../../../common/validations-Schemas-recepcion'
import { Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import {LoadingComponent} from 'recupero-comunes'
import Acciones from './acciones'

const RecepcionaCasoAsignado = () => {
  
  const [loading, setLoading]=useState(false)
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const {
   
    comboAmbitoGestion,
    datosGestion,
    llaves
  } = data_recepciona
  const dispatch = useDispatch()
 
  const [isAmbito, setIsAmbito]=useState(false)
  const [isModoContacto, setIsModoContacto]=useState(false)
  const [isRespuestaContacto, setIsRespuestaContacto]=useState(false)
  const [accion, setAction]=useState("")
  const [showToast, setShowToast] = useState(false);
  const handleCloseToast = () => setShowToast(false)
  const handleShowToast = () => setShowToast(true) 
  useEffect(() => {
    if(llaves){
      setLoading(true)
      let query = Buffer.from(
       JSON.stringify({"rutcia":llaves && llaves["idOrgCaso"], idform: 41})
     ).toString('base64')
     dispatch(configuracionFormAction41(query))
     .then(()=>{
      let query = Buffer.from(
        JSON.stringify({idCaso:llaves && llaves["idCaso"], idImplicado: llaves && llaves["idImplicado"]})
      ).toString('base64')
      dispatch(obtenerDatosGestion(query))
     })
     .then(()=>{
      let query = Buffer.from(
        JSON.stringify({concepto: 232})
      ).toString('base64')
      dispatch(obtenerComboAmbitoGestion(query))
     }).then(()=>setLoading(false))
    }
  }, [dispatch,llaves])
  
  const formik = useFormik({
    initialValues: {
      "idCaso":"",
      "idImplicadoCaso":"",
      "idOrganizacion":"",
      "idCarpetaResExt":"",
      "codTipoGestion": "",
      "codAmbitoGestion": "",
      "glosaAmbitoGestion": "",
      "codIntanciaGestion":"",
      "fechaAudiencia":"",
      "codHitoContacto": "",
      "fechaHitoContacto": "",
      "minutaHitoContacto": "",
      "codHitoRespuesta": "",
      "fechaHitoRespuesta": "",
      "minutaHitoRespuesta": "",
      "recepciona": "",
      "aliasApp": "",
      "idUsuario":""

    },
    validationSchema: validationSchemas(isModoContacto,isRespuestaContacto),
    onSubmit: (formData) => {    
      const dataForm = { ...formData }
      if(accion==="Actualizar"){
        dataForm["recepciona"]=0
      }else{
        dataForm["recepciona"]=1

      }
      const glozaAmbito=comboAmbitoGestion && comboAmbitoGestion.comboAmbitoGestion.find(c=>c.id===parseInt(formData["codAmbitoGestion"]))?.nombre
     
      dataForm["idCaso"]=llaves && llaves["idCaso"]
      dataForm["idImplicadoCaso"] = 0 //Se registra para Asegurado (Caso) llaves && llaves["idImplicado"]
      dataForm["idOrganizacion"]=llaves && llaves["idOrgCaso"]
      dataForm["idUsuario"]=llaves && llaves["idUsuario"]
      dataForm["glosaAmbitoGestion"]=glozaAmbito
      dataForm["aliasApp"]="RESCASODEF"
      dataForm["codTipoGestion"]=datosGestion && datosGestion.datosGestion[0]["codTipoGestion"]
      dispatch(PostRecepciona(dataForm))
      handleShowToast()
    }
  })
  return (
    <div>
     <LoadingComponent show={loading}/>
     <Form onSubmit={formik.handleSubmit}>
        <AdministraciónCaso setIsAmbito={setIsAmbito} isAmbito={isAmbito} formik={formik} setShowToast={setShowToast} showToast={showToast}/>
        
        <Acciones setAction={setAction}/>
      </Form>
    </div>
  )
}

export default RecepcionaCasoAsignado